var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "#D4EEF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 25C30.5 25 32 26 33 28M28 22C23.5817 22 20 25.5817 20 30C20 31.4571 20.3896 32.8233 21.0703 34M28 22C32.4183 22 36 25.5817 36 30C36 31.4571 35.6104 32.8233 34.9297 34M28 22C28.8284 22 29.5 21.3284 29.5 20.5C29.5 19.6716 28.8284 19 28 19C27.1716 19 26.5 19.6716 26.5 20.5C26.5 21.3284 27.1716 22 28 22ZM20.5 37H35.5C36.3284 37 37 36.3284 37 35.5C37 34.6716 36.3284 34 35.5 34H20.5C19.6716 34 19 34.6716 19 35.5C19 36.3284 19.6716 37 20.5 37Z",
    stroke: "#19292F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.f02cccf69768700849ae95597c94b5a7.svg";
export { ForwardRef as ReactComponent };